import type React from 'react'

import { useQuery } from 'react-query'

import PlusIcon from '@/assets/icons/icon-plus.svg'
import { Page } from '@/components/layout/page/page'
import { Button } from '@/components/ui/button'
import { DataTable } from '@/components/ui/table/data-table'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { openDialog } from '@/models/dialogs.ts'
import { useListsTableColumns } from '@/modules/tiktok-research/lists/hooks/useListsTableColumns.tsx'
import { getLists } from '@/modules/tiktok-research/service'
import { TikTokListsPageSkeleton } from '@/modules/tiktok-research/skeletons/TikTokListsPageSkeleton.tsx'
import { handleError } from '@/utils/error'

export const TikTokLists: React.FC = () => {
  const { isFetching, data, refetch } = useQuery('lists', getLists, {
    onError: (error) => handleError(error, 'Failed to get lists', refetch),
  })
  const columns = useListsTableColumns()
  const openEditModal = () => {
    openDialog({
      type: DIALOG_TYPE.CREATE_OR_EDIT_TIKTOK_LIST_DIALOG,
      isPersistent: true,
    })
  }

  if (isFetching || !data) {
    return <TikTokListsPageSkeleton />
  }

  return (
    <Page
      title="My Lists"
      description="Save videos and sounds to lists"
      headerOptions={
        <Button
          variant="default"
          onClick={openEditModal}
        >
          <PlusIcon className="mr-1" />
          Create List
        </Button>
      }
    >
      <DataTable
        className="px-6"
        columns={columns}
        data={data}
      />
    </Page>
  )
}
